import React, { useEffect, useState } from "react";
import Slider from "../Slider/Slider";
import HorizontalAdV2 from "../Ads/HorizontalAdV2";
import WhiteStorieCard from "../StorieCards/White/WhiteStorieCard";
import BlackStorieCard from "../StorieCards/Black/BlackStorieCard";
import SlideCards2 from "../StorieCards/Slide/SlideCards2";
import StorieSlider2 from "../StorieSlider/StorieSlider2";   // Round circle for celebrities
import Videos from "../Videos/Videos";
import ShortVideos from "../Videos/ShortVideos";
import Meta from "../Meta/Meta";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import RealtedArticel from "../RelatedArticel/RelatedArticel";
import AudioBlock from "../Audio/AudioBlock";
const Home = () => {
    const { lang } = useParams();   // ✅ GET FROM URL
    const [isLoading, setIsLoading] = useState(true);
    const [apidata, setApiData] = useState({ metadata: {}, homedata: [] });

    const fetchData = async () => {
    try {
        const currentLang = lang || Cookies.get("lg") || "en";

        Cookies.set("lg", currentLang);

        const response = await fetch(
             `/api/${currentLang}/homepage`,
            { method: "POST" }
        );

        const result = await response.json();

        if (result?.status === 1) {
            setApiData(result.data);
        }
    } catch (err) {
        console.error(err);
    } finally {
        setIsLoading(false);
    }
};

   useEffect(() => {
    if (lang) {
        Cookies.set("lg", lang);   // ✅ store language
    }
    fetchData();
}, [lang]);

    if (isLoading) return <div className="text-center mt-5">Loading...</div>;
    if (!apidata?.homedata?.length) return <div className="text-center mt-5">No Data Found</div>;

    const { metadata, homedata } = apidata;

    const renderSection = (section, index) => {
        const { type, title = "", url = "", list = [] } = section;
        if (!list?.length) return null;

        switch (type) {
            case "main-slider":
                return <Slider key={index} list={list} />;

            case "light-block":
                return <WhiteStorieCard key={index} title={title} url={url}>{list}</WhiteStorieCard>;

            case "dark-block":
                return <BlackStorieCard key={index} title={title} url={url}>{list}</BlackStorieCard>;

            case "celebrities-circle":                    // ← Changed to this
                return <StorieSlider2 key={index} title={title} url={url} list={list} />;

            case "number-slider":
                return <SlideCards2 key={index} title={title} url={url}>{list}</SlideCards2>;

            case "numerology-block":
                return <WhiteStorieCard key={index} title={title} url={url}>{list}</WhiteStorieCard>;

case "trending-block":
                return <RealtedArticel key={index} title={title} url={url}>{list}</RealtedArticel>;

            case "youtube-videos":
                return <Videos key={index} title={title} url={url}>{list}</Videos>;
                
case "audio-block":
    return <AudioBlock key={index} title={title} url={url} list={list} />;
            case "short-videos":
                return <ShortVideos key={index} title={title} url={url}>{list}</ShortVideos>;

            case "horizontal-ad":
                return <HorizontalAdV2 key={index} {...section} />;

            default:
                console.warn("Unknown type:", type);
                return null;
        }
    };

    return (
        <>
            <Meta metadata={metadata} />
            {homedata.map(renderSection)}
        </>
    );
};

export default Home;